import { BouncySumsSceneStatus, BouncySumsScreen } from '@/features/bouncySums/constants';

import type { BouncySumsConfig, BouncySumsSceneStateEvent } from '@/features/bouncySums/types';

type UseBouncySumsGameStateParams = {
	activeScreen: BouncySumsScreen;
	config: BouncySumsConfig;
	sceneState: BouncySumsSceneStateEvent | null;
	selectedTables: number[];
};

export function useBouncySumsGameState({
	activeScreen,
	config,
	sceneState,
	selectedTables,
}: UseBouncySumsGameStateParams) {
	const isGameScreen = activeScreen === BouncySumsScreen.GAME;

	return {
		bpm: sceneState?.bpm ?? config.bpm,
		endScreenTables: selectedTables.length ? selectedTables : config.tables,
		isEndScreenVisible: isGameScreen && sceneState?.status === BouncySumsSceneStatus.FINISHED,
		isGameScreen,
		isGameplayInputVisible: isGameScreen && sceneState?.status === BouncySumsSceneStatus.PLAYING,
		previousHighScore: sceneState?.previousHighScore ?? config.highScore,
		progress: Math.min(100, Math.max(0, (sceneState?.progress ?? 0) * 100)),
		score: sceneState?.score ?? 0,
		seconds: sceneState?.timeRemainingSeconds ?? config.gameTimeSeconds,
	};
}
